import { combineReducers } from "redux-immutable";

import { menuReducer } from "./menu";

export default combineReducers({
	menu: menuReducer
});
